import { render, staticRenderFns } from "./dm-detail-ppt.vue?vue&type=template&id=455e4380&scoped=true"
import script from "./dm-detail-ppt.vue?vue&type=script&lang=js"
export * from "./dm-detail-ppt.vue?vue&type=script&lang=js"
import style0 from "./dm-detail-ppt.vue?vue&type=style&index=0&id=455e4380&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455e4380",
  null
  
)

export default component.exports